import { Channel, SimpleChannel } from '@ibe/services';
import VideoPlayerEvent from './Channel/payload/VideoPlayerEvent.js';
import AuthenticateState from '../Services/Auth/Models/AuthenticateState.js';

var VideoLinkEvent = new Channel(VideoPlayerEvent, 'video-link-loaded');
var VideoStreamEvent = new Channel(VideoPlayerEvent, 'video-stream-completed');
var UpsellButtonEvent = new Channel(VideoPlayerEvent, 'upsell-button-clicked');
var VideoPlayEvent = new Channel(VideoPlayerEvent, 'play-button-clicked');
var VideoPauseEvent = new Channel(VideoPlayerEvent, 'pause-button-clicked');
var loginEvent = new Channel(AuthenticateState, 'login');
var logoutEvent = new SimpleChannel('logout');

export { UpsellButtonEvent, VideoLinkEvent, VideoPauseEvent, VideoPlayEvent, VideoStreamEvent, loginEvent, logoutEvent };
//# sourceMappingURL=commonEvents.js.map
